// 玩家執行階段狀態存放區（餘額、下注、Turbo、AutoSpin、ExtraBet）。
// 對應 Unity GameStateData / PlayerBetData。為執行階段 store，允許受控變更。
import { EXTRA_BET_MULTIPLE } from '../constants'

export const DEFAULT_BET_OPTIONS = [1, 2, 5, 10, 20, 50, 100] as const

export class PlayerState {
  balance: number
  private readonly betOptions: readonly number[]
  private betIndex = 0
  turbo = false
  extraBet = false
  autoRemaining = 0
  autoInfinite = false

  constructor(balance = 10_000, betOptions: readonly number[] = DEFAULT_BET_OPTIONS) {
    this.balance = balance
    this.betOptions = betOptions
  }

  get bet(): number {
    return this.betOptions[this.betIndex]
  }

  /** 本次旋轉的總投注（ExtraBet 時 ×1.5）。 */
  get totalBet(): number {
    return this.extraBet ? this.bet * EXTRA_BET_MULTIPLE : this.bet
  }

  get betOptionCount(): number {
    return this.betOptions.length
  }

  get betOptionIndex(): number {
    return this.betIndex
  }

  cycleBet(direction: 1 | -1): void {
    const count = this.betOptions.length
    this.betIndex = (this.betIndex + direction + count) % count
  }

  get autoActive(): boolean {
    return this.autoInfinite || this.autoRemaining > 0
  }

  startAuto(count: number): void {
    if (count <= 0) {
      this.autoInfinite = true
      this.autoRemaining = 0
    } else {
      this.autoInfinite = false
      this.autoRemaining = count
    }
  }

  consumeAuto(): void {
    if (!this.autoInfinite && this.autoRemaining > 0) this.autoRemaining -= 1
  }

  cancelAuto(): void {
    this.autoInfinite = false
    this.autoRemaining = 0
  }
}
